import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "max-w-[25rem] self-center justify-self-center" }
const _hoisted_2 = { class: "h6 tablet:h5" }
const _hoisted_3 = { class: "mt-4 text-14 text-black-700 tablet:text-16" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mb-32 flex flex-col gap-y-24" }
const _hoisted_6 = { class: "text-16" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "text-16" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString($data.locale.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString($data.locale.subtitle), 1),
    ($data.errorMessageMap.has($data.fetchStatus))
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "mt-8 block text-16 text-red tablet:mt-12",
          innerHTML: $data.errorMessageMap.get($data.fetchStatus)
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "mt-28",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.fetchOrder && $options.fetchOrder(...args)), ["prevent"]))
    }, [
      _createElementVNode("fieldset", _hoisted_5, [
        _createElementVNode("label", null, [
          _createElementVNode("span", _hoisted_6, _toDisplayString($data.locale.order_number_input_label), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.orderNumber) = $event)),
            required: "",
            type: "text",
            name: "orderNumber",
            pattern: "^[A-Za-z0-9#]+$",
            placeholder: $data.locale.order_number_input_placeholder,
            class: "mt-12 w-full border border-black-400 py-8 indent-16 text-16 focus:border-black-900"
          }, null, 8, _hoisted_7), [
            [_vModelText, $data.orderNumber]
          ])
        ]),
        _createElementVNode("label", null, [
          _createElementVNode("span", _hoisted_8, _toDisplayString($data.locale.email_input_label), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.email) = $event)),
            required: "",
            name: "email",
            type: "email",
            autocomplete: "email",
            autocorrect: "off",
            autocapitalize: "off",
            placeholder: $data.locale.email_input_placeholder,
            class: "mt-12 w-full border border-black-400 py-8 indent-16 text-16 focus:border-black-900"
          }, null, 8, _hoisted_9), [
            [_vModelText, $data.email]
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["btn btn-primary btn-small tablet:btn-medium w-full", {loading: $data.fetchStatus === 'LOADING'}])
      }, _toDisplayString($data.locale.find_order_button), 3),
      _createElementVNode("a", {
        href: $data.homepageUrl,
        class: "btn btn-accent mx-auto mt-24 w-fit"
      }, _toDisplayString($data.locale.return_to_homepage_link), 9, _hoisted_10)
    ], 32)
  ]))
}